export const reviewStyles = {
  gappedItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
  },
  largeGap: {
    gap: '3rem',
  },
}


